import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import { AiOutlineHome, AiOutlineMail } from "react-icons/ai";
import { BiPhoneCall, BiInfoCircle } from "react-icons/bi";
 import * as yup from 'yup'
import { useFormik } from 'formik' 
import { useDispatch , useSelector} from 'react-redux'
import { createQuery } from "../features/contact/contactSlice";
 import  "../styles/Contact.css"

const contactSchema = yup.object({
  name: yup.string().required("Name is Required"),
  email: yup.string().nullable().email("Email should be valid.").required("Email is Required"),
  mobile: yup.string().default('').nullable().required("Mobile Number is Required."),
  comment: yup.string().default('').nullable().required("Comment is Required."),
});

const Contact = () => {
  const dispatch = useDispatch();
  const { isLoading, isSuccess } = useSelector((state) => state.contact);
  
  const formik = useFormik({
    initialValues: {
      name: '',
      mobile: '',
      email: '',
      comment: ""
    },
    validationSchema: contactSchema,
    onSubmit: (values, { resetForm }) => {
      dispatch(createQuery({
        name: values.name,
        email: values.email,
        mobile: values.mobile,
        comment: values.comment
      }));
      resetForm();  
    },
  });
  
  return (
    <>
    <Meta 
      title="Contact Us - Savannah Shine Hub"
       />
       <div className="contact-wrapper">
      
         
          
            <div className="contact-inner-wrapper d-flex justify-content-between ">
              <div>
                <h3 className="contact-title mb-4">Contact</h3>
                <form onSubmit={formik.handleSubmit} className="d-flex flex-column gap-15">
                  <div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                      name="name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                    />
                    <div className="errors">
                      {formik.touched.name && formik.errors.name}
                    </div>
                  </div>
                  <div>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      name="email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                    />
                    <div className="errors">
                      {formik.touched.email && formik.errors.email}
                    </div>
                  </div>
                  <div>
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="Mobile Number"
                      name="mobile"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.mobile}
                    />
                    <div className="errors">
                      {formik.touched.mobile && formik.errors.mobile}
                    </div>
                  </div>
                  <div>
                    <textarea
                      id=""
                      className="w-100 form-control"
                      cols="30"
                      rows="4"
                      placeholder="Comments"
                      name="comment"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.comment}
                    ></textarea>
                    <div className="errors">
                      {formik.touched.comment && formik.errors.comment}
                    </div>
                  </div>
                  <div>
                  <button
                      type="submit"
                      className="button contact-btn border-0"
                      disabled={isLoading} // Disable when submitting
                    >
                      {isLoading ? "Submitting..." : "Submit"}
                    </button>
                        </div>
                </form>
              </div>
              <div>
                <h3 className="contact-title mb-4">Get in touch with us</h3>
                <div className="contact-info">
                <ul>
                  <li>
                    <AiOutlineHome className="icon" />
                    <address>
                      Northern Bypass Junction,<br />
                      100m along Kwaheri Rd
                    </address>
                  </li>

                  <li>
                    <BiPhoneCall className="icon" />
                    <a href="tel:+254119117744">+254 119 117 744</a>
                  </li>

                  <li>
                    <AiOutlineMail className="icon" />
                    <a href="mailto:info@savannahshinehub.com">
                      info@savannahshinehub.com
                    </a>
                  </li>

                  <li>
                    <BiInfoCircle className="icon" />
                    <p>Monday – Saturday 8 AM – 5 PM</p>
                  </li>
                </ul>
              </div>
              </div>
            </div>
         
       
       
      </div>
    </>
  );
};

export default Contact;